import { getNumberValuesToCompare, isArrayOfNumbers, isValueEmpty, lessThan } from '../utils';
export function valueIsLessThan(givenValue, expectedValue, orEqual = false) {
    if (isValueEmpty(givenValue)) {
        return false;
    }
    const values = getNumberValuesToCompare(givenValue, expectedValue);
    if (isArrayOfNumbers(values)) {
        const [given, expected] = values;
        return lessThan(given, expected, orEqual);
    }
    throw new Error(`LessThan operator: Unsupported values to compare ${givenValue}, ${expectedValue}`);
}

//# sourceMappingURL=less-than.js.map